import React, { useState } from 'react';

const LocationModal = ({
  show,
  onClose,
  formData,
  onChange,
  onSave,
  isEditMode,
  isLoading,
}) => {
  const [touchedFields, setTouchedFields] = useState({
    location_name: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mark field as touched when submitting
    setTouchedFields({
      location_name: true
    });

    // Check if field is valid
    if (formData.location_name?.trim()) {
      onSave();
    }
  };

  const handleBlur = (fieldName) => {
    if (!touchedFields[fieldName]) {
      setTouchedFields(prev => ({
        ...prev,
        [fieldName]: true
      }));
    }
  };

  const shouldShowValidation = () => {
    return touchedFields.location_name && !formData.location_name?.trim();
  };

  if (!show) return null;

  return (
    <>
      {/* Modal Overlay */}
      <div
        className="modal-backdrop show"
        style={{
          zIndex: 1050,
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      ></div>

      {/* Modal Dialog */}
      <div
        className="modal d-block"
        tabIndex="-1"
        style={{ zIndex: 1060 }}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-lg" role="document">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title">
                {isEditMode ? 'Edit Location' : 'Add Location'}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              />
            </div>

            {/* Body */}
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="locationName"
                    className="form-label fw-semibold"
                  >
                    Location Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="locationName"
                    name="location_name"
                    className={`form-control ${shouldShowValidation() ? 'is-invalid' : ''}`}
                    placeholder="Enter location name"
                    value={formData.location_name || ''}
                    onChange={onChange}
                    onBlur={() => handleBlur('location_name')}
                    required
                  />
                  {shouldShowValidation() && (
                    <div className="invalid-feedback">Location name is required</div>
                  )}
                </div>
              </form>
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading
                  ? isEditMode
                    ? 'Updating...'
                    : 'Saving...'
                  : isEditMode
                  ? 'Update Location'
                  : 'Save Location'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationModal;